// extracted by mini-css-extract-plugin
module.exports = {"innerContainer":"Education_innerContainer__176Cp","boxContainer":"Education_boxContainer__3cPcz","title":"Education_title__36FH2","img":"Education_img__2-LdQ"};